import { token } from '@terra/ui-styled-system';
import type { CvssMetricTone } from './finding-cvss-tab-metrics';

export type CvssToneStyle = { bg: string; border: string; fg: string };

export const CVSS_TONE_STYLES: Record<
  CvssMetricTone | 'unknown',
  CvssToneStyle
> = {
  raises: {
    bg: token('colors.bg.severity.high'),
    border: token('colors.border.severity.high'),
    fg: token('colors.fg.severity.high'),
  },
  some: {
    bg: token('colors.bg.severity.medium'),
    border: token('colors.border.severity.medium'),
    fg: token('colors.fg.severity.medium'),
  },
  lowers: {
    bg: token('colors.bg.severity.low'),
    border: token('colors.border.severity.low'),
    fg: token('colors.fg.severity.low'),
  },
  unknown: {
    bg: token('colors.bg.neutral.subtle'),
    border: token('colors.border.neutral.muted'),
    fg: token('colors.fg.muted'),
  },
};
